import * as JSONMapper from 'json-mapper';
import { JSONMapped, jsonProperty } from 'json-mapper-reflect';
import { Money } from 'money';
import { AvdbPricingMapRegionID } from './avdb-pricing-map-region';
import { AvdbPricingProductSeries } from './avdb-pricing-product-series';
import { AvdbPricingProductType } from './avdb-pricing-product-type';

export class AvdbPricingProduct extends JSONMapped() {
	@jsonProperty()
	partKey: string;

	@jsonProperty(JSONMapper.classByMethods(Money))
	price: Money;

	@jsonProperty()
	numberOfIssues: number;

	@jsonProperty(JSONMapper.arrayOfClass(AvdbPricingProductSeries))
	series: Array<AvdbPricingProductSeries>;

	// Set by services
	productType: AvdbPricingProductType;

	constructor(data?: Partial<AvdbPricingProduct>) {
		super();
		Object.assign(this, data);
	}

	equals(other: AvdbPricingProduct): boolean {
		return this.partKey === other.partKey;
	}

	get partNumber(): string {
		return this.partKey;
	}

	get numberOfIssuesDisplay(): string {
		return (this.numberOfIssues === 1) ? "1 Update" : `${this.numberOfIssues} Updates`;
	}

	get subscriptionDuration(): string {
		if (this.productType != null && this.productType.purchasableOnlyForAnnualSubscription) {
			return '1 Year';
		} else {
			return (this.numberOfIssues > 1) ? '1 Year' : `1 Month`;
		}
	}

	get maxNumberOfIssues(): number {
		return _.max(
			this.series.map(s => _.max(s.coverageDurationOptions.map(o => o.numberOfIssues))));
	}

	coversMapRegions(mapRegions: Array<AvdbPricingMapRegionID>, includeCompleteCoverageOnly: boolean): boolean {
		return mapRegions.every(mapRegionId =>
			this.series.some(series =>
				series.coversMapRegions([mapRegionId], includeCompleteCoverageOnly)
			)
		);
	}
}
